module.exports = __webpack_public_path__ + "media/images/sugerencias-titulo-01792ef6e0d601b2b3cf751a05fb138a.png";